import { NaluriVideoErrorConstants } from '@/constants/errors';

export class NaluriAccountError extends Error {
  public error: boolean;

  public message: string;

  constructor({ message }: { message: string }) {
    super(message);
    this.error = true;

    console.debug('NaluriVideoError', message);
    this.message = message || 'Unknown Naluri Video error.';

    Object.setPrototypeOf(this, NaluriAccountError.prototype);
    Error.captureStackTrace(this, NaluriAccountError);
  }
}

export class NaluriRefreshTokenError extends NaluriAccountError {
  constructor() {
    super({ message: 'Refresh token failed.' });
    Object.setPrototypeOf(this, NaluriRefreshTokenError.prototype);
    Error.captureStackTrace(this, NaluriRefreshTokenError);
  }
}

export type NaluriVideoErrorCode =
  (typeof NaluriVideoErrorConstants)[keyof typeof NaluriVideoErrorConstants];

export class NaluriVideoError extends Error {
  readonly code: NaluriVideoErrorCode;
  readonly statusCode: number;

  constructor({
    message,
    code,
    statusCode,
  }: {
    message: string;
    code: NaluriVideoErrorCode;
    statusCode: number;
  }) {
    super(message);
    this.code = code;
    this.statusCode = statusCode;
    this.message = message || 'Unknown Naluri Video error.';
    Object.setPrototypeOf(this, NaluriVideoError.prototype);
    Error.captureStackTrace(this, NaluriVideoError);
  }
}
